/* Raambord.nl – ATC-feedback (22-10-2026)
 * Visuele feedback op de "In winkelwagen"-knop: direct bezig-status, herstel bij drawer-open,
 * validatie of fout, vangnet-timeout en blokkade van dubbele klikken.
 * Raakt Customily-code niet aan; luistert alleen naar DOM-events. Elke fout wordt afgevangen,
 * zodat het toevoegen aan de winkelwagen nooit door dit script kan breken.
 */
(function () {
  'use strict';
  try {
    if (!window.document || !document.querySelector || typeof window.MutationObserver !== 'function') return;
    if (window.__rbAtcFeedback) return;
    window.__rbAtcFeedback = true;

    var BUSY_TEXT = 'Toevoegen\u2026';
    var FAILSAFE_MS = 9000;
    var DEBUG = /[?&]rb_atc_debug=1/.test(window.location.search);
    var state = null; // { btn, label, text, timer, t0 }

    function log() {
      if (!DEBUG || !window.console) return;
      try { console.log.apply(console, ['[rb-atc]'].concat([].slice.call(arguments))); } catch (e) {}
    }

    // Spinner-stijl (alleen actief met .rb-atc-busy; overlapt niet met Customily's .running-loader)
    try {
      var css = '.rb-atc-busy{cursor:progress!important;opacity:.85}' +
        '.rb-atc-busy .rb-atc-spinner{display:inline-block;width:1em;height:1em;margin-right:.5em;vertical-align:-.15em;' +
        'border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:rb-atc-spin .8s linear infinite}' +
        '@keyframes rb-atc-spin{to{transform:rotate(360deg)}}' +
        '@media (prefers-reduced-motion:reduce){.rb-atc-busy .rb-atc-spinner{animation:none}}';
      var st = document.createElement('style');
      st.id = 'rb-atc-feedback-style';
      st.appendChild(document.createTextNode(css));
      (document.head || document.documentElement).appendChild(st);
    } catch (e) {}

    // De zichtbare ATC-knop: Customily vervangt de themaknop door #customily-cart-btn (type=button).
    function findAtcButton(target) {
      if (!target || !target.closest) return null;
      var btn = target.closest('#customily-cart-btn, product-form button[name="add"]');
      if (!btn) return null;
      if (!btn.closest('product-form') && btn.id !== 'customily-cart-btn') return null;
      return btn;
    }

    function isUsable(btn) {
      if (!btn || btn.disabled) return false;
      if (btn.getAttribute('aria-disabled') === 'true') return false;
      if (btn.offsetParent === null) return false; // verborgen (bv. originele knop onder Customily)
      return true;
    }

    function labelOf(btn) {
      return btn.querySelector('[id^="AddToCartText"]') || btn.querySelector('span') || null;
    }

    function setBusy(btn) {
      var label = labelOf(btn);
      state = { btn: btn, label: label, text: label ? label.textContent : null, t0: Date.now(), timer: null };
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('rb-atc-busy');
      if (label) {
        label.textContent = BUSY_TEXT;
        var sp = document.createElement('span');
        sp.className = 'rb-atc-spinner';
        sp.setAttribute('aria-hidden', 'true');
        label.insertBefore(sp, label.firstChild);
      }
      state.timer = window.setTimeout(function () { restore('timeout'); }, FAILSAFE_MS);
      log('busy');
    }

    function restore(reason) {
      if (!state) return;
      var s = state;
      state = null;
      try {
        window.clearTimeout(s.timer);
        if (s.label && s.text !== null) s.label.textContent = s.text;
        s.btn.classList.remove('rb-atc-busy');
        s.btn.removeAttribute('aria-busy');
        s.btn.disabled = false;
        log('restore', reason, (Date.now() - s.t0) + 'ms');
        if (reason === 'drawer') updateBadge();
      } catch (e) {}
    }

    // Optioneel: badge bijwerken vanuit /cart.js (alleen tekst van #CartCount).
    function updateBadge() {
      try {
        if (typeof window.fetch !== 'function') return;
        window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart || typeof cart.item_count !== 'number') return;
            var el = document.getElementById('CartCount');
            if (el && el.textContent !== String(cart.item_count)) el.textContent = String(cart.item_count);
          })['catch'](function () {});
      } catch (e) {}
    }

    function visibleRequiredLabels() {
      var n = 0;
      try {
        // Customily toont 'Verplicht' door de display:none van de binnenste span weg te halen.
        var els = document.querySelectorAll('.customily-required-label span, .customily-required-label + .cl-error, .cl-option-error');
        for (var i = 0; i < els.length; i++) {
          if (els[i].offsetParent !== null && (els[i].textContent || '').trim()) n++;
        }
      } catch (e) {}
      return n;
    }

    // Klik op de ATC-knop: alleen observeren; status pas na de huidige event-dispatch zetten,
    // zodat de handlers van thema en Customily ongestoord dezelfde klik verwerken.
    document.addEventListener('click', function (ev) {
      try {
        var btn = findAtcButton(ev.target);
        if (!btn) return;
        if (state && state.btn === btn) { // dubbele klik tijdens bezig
          ev.preventDefault();
          ev.stopImmediatePropagation();
          log('dubbele klik geblokkeerd');
          return;
        }
        if (!isUsable(btn)) return;
        var form = btn.closest('product-form') ? btn.closest('product-form').querySelector('form') : null;
        if (form && typeof form.checkValidity === 'function' && !form.checkValidity()) return; // browser-validatie toont zelf de melding
        var labelsBefore = visibleRequiredLabels();
        window.setTimeout(function () {
          try {
            if (state) return;
            setBusy(btn);
            state.labelsBefore = labelsBefore;
            state.sawRunning = btn.classList.contains('running');
          } catch (e) {}
        }, 0);
      } catch (e) {}
    }, true);

    // Vangnet tegen dubbele submits van het formulier terwijl de zichtbare knop bezig is
    // wordt bewust NIET gedaan: Customily dient na zijn validatie zelf het formulier in
    // via de verborgen originele knop; die submit moet altijd doorgaan.

    // Browser-validatie (invalid-veld) => herstel.
    document.addEventListener('invalid', function () { restore('invalid'); }, true);

    var mo = new MutationObserver(function (muts) {
      if (!state) return;
      try {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i], t = m.target;
          if (m.type === 'attributes') {
            // Cart drawer open
            if (t.tagName === 'CART-DRAWER' && m.attributeName === 'class' && t.classList.contains('active')) { restore('drawer'); return; }
            // Customily stopt zijn eigen loader (.running) terwijl er een 'Verplicht'-melding staat => validatie
            if (t === state.btn && m.attributeName === 'class') {
              if (t.classList.contains('running')) state.sawRunning = true;
              else if (state.sawRunning && visibleRequiredLabels() > 0) { restore('validation'); return; }
            }
            // Fout van het thema (product-form .pform-error-wrap zichtbaar)
            if (m.attributeName === 'hidden' && t.classList && t.classList.contains('pform-error-wrap') && !t.hasAttribute('hidden')) { restore('error'); return; }
          }
        }
        // Customily 'Verplicht'-melding verschenen
        if (visibleRequiredLabels() > (state.labelsBefore || 0)) { restore('validation'); return; }
      } catch (e) { restore('observer-error'); }
    });

    function startObserver() {
      try {
        mo.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
      } catch (e) {}
    }

    // Elke andere situatie (bv. een Customily-fout zonder melding) valt onder het vangnet (FAILSAFE_MS).

    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver);

    // Terug naar de pagina via bfcache: nooit in bezig-status blijven hangen.
    window.addEventListener('pageshow', function () { restore('pageshow'); });
  } catch (err) {
    try { window.console && console.warn && console.warn('[rb-atc] uitgeschakeld:', err); } catch (e) {}
  }
})();
